import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MobileHeader = _resolveComponent("MobileHeader")!
  const _component_SiteHeader = _resolveComponent("SiteHeader")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MobileHeader),
    _createVNode(_component_SiteHeader),
    _createVNode(_component_router_view)
  ], 64))
}